import React from 'react';
import TrackPicker from './TrackPicker';

/**
 * One-time, first-login course-track picker. Pre-selects sensible defaults so
 * "Start learning" works immediately — this is a quick confirm, not a form.
 */
export default function TrackOnboardingModal({ language, level, onSave }) {
  return (
    <div className="track-onboarding-overlay" role="dialog" aria-modal="true" aria-label="Choose your course track">
      <div className="track-onboarding-card">
        <div className="track-onboarding-eyebrow">Before we start</div>
        <h2 className="track-onboarding-title">Which track are you studying?</h2>
        <p className="track-onboarding-sub">
          This sets the language and level you see across the course. You can change it
          anytime from the chip next to your name.
        </p>
        <TrackPicker language={language} level={level} onSave={onSave} variant="onboarding" />
      </div>
    </div>
  );
}
